\<!-- Account Information-->
<section *ngIf=!resetMode>
    <div class="container content-box">
        <h1 class="text-center">My Account</h1>

        <!-- Update Form -->
        <form name="form" (submit)="f.form.valid && onUpdate(f)" #f="ngForm" novalidate>

            <!-- User Info Fields-->
            <div class="col-md-12">

                <!-- Email -->
                <div class="row mt-2">
                    <div class="col-md-12 mt-2"><label>Email:</label><input disable type="text" class="form-control" placeholder="{{user.email || 'email'}}" [(ngModel)]="user.email" #email="ngModel" [ngClass]="{disabledDiv: !isActiveDiv}"></div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- First Name -->
                    <div class="col-md-5">
                        <label class="required-field">First Name</label>
                        <input type="text" id="firstName" class="form-control mb-2" [(ngModel)]="user.firstName" [ngModelOptions]="{standalone: true}" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" name="firstName" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="firstName.errors!.required">First name is required</div>
                        </div>
                    </div>

                    <!-- Middle Initial -->
                    <div class="col-md-2">
                        <label>MI</label>
                        <input type="text" id="middleInitial" class="form-control mb-2" [(ngModel)]="user.middleInitial" [ngModelOptions]="{standalone: true}"#middleInitial="ngModel" name="middleInitial">
                    </div>

                    <!-- Last Name -->
                    <div class="col-md-5">
                        <label class="required-field">Last Name</label>
                        <input type="text" id="lastName" class="form-control mb-2" [(ngModel)]="user.lastName" [ngModelOptions]="{standalone: true}"name="lastName" #lastName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && lastName.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="lastName.errors!.required">Last name is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2">

                  <!-- Are you under the age of 18? -->
                  <div class="col-md-12 check">
                    <label for="ageUnder18" class="required-field form-check-label">Are you under the age of 18?</label>
                    <input type="hidden" [(ngModel)]="user.ageUnder18" [ngModelOptions]="{standalone: true}" #ageUnder18="ngModel" class="form-control" name="ageUnder18">

                    <!-- Yes or No -->
                    <div class="input-group" [ngClass]="{ 'is-invalid': f.submitted && ageUnder18.invalid }">
                      <button class="btn custom" type="button" [ngClass]="[user.ageUnder18 === true ? 'btn-primary' : 'btn-outline-primary']" (click)="setAgeUnder18(true)">Yes</button>
                      <button class="btn custom" type="button" [ngClass]="[user.ageUnder18 !== true ? 'btn-primary' : 'btn-outline-primary']" (click)="setAgeUnder18(false)">No</button>
                    </div>

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && ageUnder18.invalid" class="invalid-feedback">
                    </div>
                  </div>
              </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">
                    <!-- Primary Role -->
                    <div [ngClass]="user.primaryRole === 'Other' || user.primaryRole === 'Housing Provider – Owner' || user.primaryRole === 'Housing Provider – Property Management' ? 'col-md-6' : 'col-md-12'">
                        <label class="required-field">Primary Role</label>
                        <select name="primaryRole" id="primaryRole" class="form-control mb-2" [(ngModel)]="user.primaryRole" name="primaryRole" #primaryRole="ngModel" [ngClass]="{ 'is-invalid': f.submitted && primaryRole.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option *ngFor="let role of primaryRoles" [ngValue]="role.value">{{ role.name }}</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && primaryRole.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="primaryRole.errors!.required">Role is required</div>
                        </div>
                    </div>

                    <!-- Primary Role: Other -->
                    <div class="col-md-6" *ngIf="user.primaryRole === 'Other'">
                        <label class="required-field">Other Role</label>
                        <input type="text" id="primaryRoleOther" class="form-control mb-2" [(ngModel)]="user.primaryRoleOther" #primaryRoleOther="ngModel" [ngClass]="{ 'is-invalid': f.submitted && primaryRoleOther.invalid }" name="primaryRoleOther" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && primaryRoleOther.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="primaryRoleOther.errors!.required">Other Role is required</div>
                        </div>
                    </div>

                    <!-- Company Name -->
                    <div class="col-md-6" *ngIf="user.primaryRole === 'Housing Provider – Owner' || user.primaryRole === 'Housing Provider – Property Management'">
                        <label class="required-field">Company Name</label>
                        <input type="text" id="companyName" class="form-control mb-2" [(ngModel)]="user.companyName" #companyName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && companyName.invalid }" name="companyName" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && companyName.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="companyName.errors!.required">Company Name is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">

                    <!-- Date of Birth -->
                    <div class="col-md-4">
                        <label class="required-field">Date of Birth</label>
                        <div class="input-group date_container">
                            <input class="form-control mb-2" matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" id="dob" name="dob" [(ngModel)]="user.dob" #dob="ngModel" [ngClass]="{ 'is-invalid': f.submitted && dob.invalid }" required>

                            <!-- Date Picker -->
                            <mat-datepicker startView="multi-year" #picker></mat-datepicker>
                            <mat-datepicker-toggle class="icon" matSuffix [for]="picker"></mat-datepicker-toggle>

                            <!-- Invalid -->
                            <div *ngIf="f.submitted && dob.invalid" class="invalid-feedback">
                                <div class="mb-2" *ngIf="dob.errors!.required">Date of birth is required</div>
                            </div>
                        </div>
                    </div>

                    <!-- Race -->
                    <div [formGroup]="form" class="col-md-5 check">
                        <label class="required-field">Race</label>

                        <!-- List of Checkboxes of Races -->
                        <div *ngFor="let race of races; let i=index">
                            <input type="checkbox" [value]="race.value" (change)="onCheckboxChange($event)" [checked]="racesTrue[i] == 1" /> {{race.name}}
                        </div>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && this.form.controls['checkArray'].invalid" class="invalid-feedback race">
                            <div class="mb-2" *ngIf="this.form.controls['checkArray'].errors?.required">At least one race is required</div>
                        </div>
                    </div>

                    <!-- Ethnicity -->
                    <div class="col-md-3">
                        <label class="required-field">Ethnicity</label>
                        <select name="isHispanic" id="isHispanic" class="form-control mb-2" [(ngModel)]="user.ethnicity" name="ethnicity" #ethnicity="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ethnicity.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="Hispanic">Hispanic</option>
                        <option value="Arabic">Arabic</option>
                        <option value="None of these">None of these</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && ethnicity.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="ethnicity.errors!.required">Ethnicity is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">

                    <!-- Disability -->
                    <div class="col md-2">
                        <label class="required-field">Disability</label>
                        <select name="disabled" id="disabled" class="form-control mb-2" [(ngModel)]="user.disabled" name="disabled" #disability="ngModel" [ngClass]="{ 'is-invalid': f.submitted && disability.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && disability.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="disability.errors!.required">Disability is required</div>
                        </div>
                    </div>

                    <!-- Number of Children -->
                    <div class="col md-5">
                        <label class="required-field">Number of Children</label>
                        <select name="numberOfChildren" id="numberOfChildren" class="form-control mb-2" [(ngModel)]="user.numberOfChildren" name="numberOfChildren" #numberOfChildren="ngModel" [ngClass]="{ 'is-invalid': f.submitted && numberOfChildren.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7 or more">7 or more</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && numberOfChildren.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="numberOfChildren.errors!.required">Number of children is required</div>
                        </div>
                    </div>

                    <!-- Marital Status -->
                    <div class="col md-5">
                        <label class="required-field">Marital Status</label>
                        <select name="maritalStatus" id="maritalStatus" class="form-control mb-2" [(ngModel)]="user.maritalStatus" name="maritalStatus" #maritalStatus="ngModel" [ngClass]="{ 'is-invalid': f.submitted && maritalStatus.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="Married">Married</option>
                        <option value="Widowed">Widowed</option>
                        <option value="Divorced or Seperated">Divorced or Seperated</option>
                        <option value="Never Married or Single">Never Married or Single</option>
                        <option value="Domestic Partnership">Domestic Partnership</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && maritalStatus.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="maritalStatus.errors!.required">Marital status is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">

                    <!-- Family Status -->
                    <div class="col md-6">
                        <label class="required-field">Family Status</label>
                        <select name="familyStatus" id="familyStatus" class="form-control mb-2" [(ngModel)]="user.familyStatus" name="familyStatus" #familyStatus="ngModel" [ngClass]="{ 'is-invalid': f.submitted && familyStatus.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="Single Person">Single Person</option>
                        <option value="Single Person with Children">Single Person with Children</option>
                        <option value="Two Person Household with Children">Two Person Household with Children</option>
                        <option value="Two Person Household without Children">Two Person Household without Children</option>
                        <option value="Other">Other</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && familyStatus.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="familyStatus.errors!.required">Family status is required</div>
                        </div>
                    </div>

                    <!-- Education -->
                    <div class="col md-6">
                        <label class="required-field">Education</label>
                        <select name="education" id="eductation" class="form-control mb-2" [(ngModel)]="user.education" name="education" #education="ngModel" [ngClass]="{ 'is-invalid': f.submitted && education.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="No formal education">No formal education</option>
                        <option value="Primary education">Primary education</option>
                        <option value="Secondary education">Secondary education or high school</option>
                        <option value="GED">GED</option>
                        <option value="Vocational qualification">Vocational qualification</option>
                        <option value="Bachelor's degree">Bachelor's degree</option>
                        <option value="Master's degree">Master's degree</option>
                        <option value="Doctorate or higher">Doctorate or higher</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && education.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="education.errors!.required">Education is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2" *ngIf="!user.ageUnder18">

                    <!-- Annual Income -->
                    <div class="col-md-6">
                        <label class="required-field">Household Annual Income</label>
                        <select name="annualIncome" id="annualIncome" class="form-control mb-2" [(ngModel)]="user.annualIncome" name="annualIncome" #annualIncome="ngModel" [ngClass]="{ 'is-invalid': f.submitted && annualIncome.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="$0 - $24,999">$0 - $24,999</option>
                        <option value="$25,000 - $49,999">$25,000 - $49,999</option>
                        <option value="$50,000 - $74,999">$50,000 - $74,999</option>
                        <option value="$75,000 - $99,999">$75,000 - $99,999</option>
                        <option value="$100,000 - $149,999">$100,000 - $149,999</option>
                        <option value="$150,000 - $249,999">$150,000 - $249,999</option>
                        <option value="$250,000 or more">$250,000 or more</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && annualIncome.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="annualIncome.errors!.required">Income is required</div>
                        </div>
                    </div>

                    <!-- Primary Source of Income -->
                    <div class="col-md-6">
                        <label class="required-field">Primary Source of Income</label>
                        <select name="incomeSource" id="incomeSource" class="form-control mb-2" [(ngModel)]="user.sourceOfIncome" name="sourceOfIncome" #incomeSource="ngModel" [ngClass]="{ 'is-invalid': f.submitted && incomeSource.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="Employment">Employment</option>
                        <option value="Unemployment">Unemployment</option>
                        <option value="SSI">SSI</option>
                        <option value="SSDI">SSDI</option>
                        <option value="TANF-ADC">TANF-ADC</option>
                        <option value="Student Loans/Grants">Student Loans/Grants</option>
                        <option value="Other">Other</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && incomeSource.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="incomeSource.errors!.required">Primary income source is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2" *ngIf="!user.ageUnder18">

                  <div class="col-md-12">
                    <!-- Street Address -->
                    <label class="required-field">Street Address 1</label>
                    <input type="text" id="address1" class="form-control mb-2" placeholder="#### StreetName St." [(ngModel)]="user.streetAddress" name="streetAddress" #streetAddress="ngModel" [ngClass]="{ 'is-invalid': f.submitted && streetAddress.invalid }" required>

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && streetAddress.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="streetAddress.errors!.required">Street address is required</div>
                    </div>
                  </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2" *ngIf="!user.ageUnder18">

                    <!-- Street Address 2 -->
                    <div class="col-md-6">
                        <label>Street Address 2</label>
                        <input type="text" id="secondary" class="form-control mb-2" placeholder="(Optional)" [(ngModel)]="user.secondary" name="secondary" #secondary="ngModel">
                    </div>

                    <!-- Phone Number -->
                    <div class="col-md-6">
                        <label class="required-field">Phone Number</label>
                        <input type="phone" id="phone" class="form-control mb-2" placeholder="###-###-####" name="phone" required [(ngModel)]="user.phone" [pattern]="phonePattern" #uname="ngModel" #phone="ngModel" [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }">

                        <!-- Invalid Phone Number-->
                        <div *ngIf="f.submitted && phone.invalid || f.submitted && uname.errors?.pattern" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="phone.errors!.required">Phone number is required</div>
                            <div class="mb-1 text-center" *ngIf="uname.errors?.pattern">Must be a valid phone number</div>
                        </div>
                    </div>
                </div>

                <!-- City -->
                <div class="row mt-2">
                    <div class="col-md-5">
                        <label class="required-field">City</label>
                        <input type="text" id="city" class="form-control mb-2" [(ngModel)]="user.city" name="city" #city="ngModel" [ngClass]="{ 'is-invalid': f.submitted && city.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="city.errors!.required">City is required</div>
                        </div>
                    </div>

                    <!-- State -->
                    <div class="col-md-3">
                        <label class="required-field">State</label>
                        <select name="state" id="state" class="form-control mb-2" placeholder="--" [(ngModel)]="user.state" name="state" #state="ngModel" [ngClass]="{ 'is-invalid': f.submitted && state.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">--</option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && state.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="state.errors!.required">State is required</div>
                        </div>
                    </div>

                    <!-- Zip Code -->
                    <div class="col-md-4" *ngIf="!user.ageUnder18">
                        <label class="required-field">Zip Code</label>
                        <input type="text" id="zipCode" class="form-control mb-2" placeholder="#####" [(ngModel)]="user.zipCode" name="zipCode" #zipCode="ngModel" [ngClass]="{ 'is-invalid': f.submitted && zipCode.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && zipCode.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="zipCode.errors!.required">Zipcode is required</div>
                        </div>
                    </div>

                    <!-- County -->
                    <div class="col-md-4" *ngIf="user.ageUnder18">
                        <label class="required-field">County</label>
                        <input type="text" id="county" class="form-control mb-2" [(ngModel)]="user.county" name="county" #county="ngModel" [ngClass]="{ 'is-invalid': f.submitted && county.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && county.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="county.errors!.required">County is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2" *ngIf="!user.ageUnder18">

                    <!-- County -->
                    <div class="col-md-3">
                        <label class="required-field">County</label>
                        <input type="text" id="county" class="form-control mb-2" [(ngModel)]="user.county" name="county" #county="ngModel" [ngClass]="{ 'is-invalid': f.submitted && county.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && county.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="county.errors!.required">County is required</div>
                        </div>
                    </div>

                    <!-- Primary Residence -->
                    <div class="col-md-4">
                        <label class="required-field">Is this your Primary Residence?</label>
                        <select name="isPrimaryResidence" id="isPrimaryResidence" class="form-control mb-2" [(ngModel)]="user.primaryResidence" name="primaryResidence" #primaryResidence="ngModel" [ngClass]="{ 'is-invalid': f.submitted && primaryResidence.invalid }" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && primaryResidence.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="primaryResidence.errors!.required">Primary residence is required</div>
                        </div>
                    </div>

                    <!-- Living Situation -->
                    <div class="col-md-5">
                        <label class="required-field">Living Situation</label>
                        <select name="livingSituation" id="livingSituation" class="form-control mb-2" [(ngModel)]="user.livingSituation" name="livingSituation" #livingSituation="ngModel" [ngClass]="{ 'is-invalid': f.submitted && livingSituation.invalid }" required value="{{user.livingSituation}}">
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option value="Living with Family/Friends">Living with Family/Friends</option>
                        <option value="Rental House">Rental House</option>
                        <option value="Apartment">Apartment</option>
                        <option value="Emergency Shelter">Emergency Shelter</option>
                        <option value="Group Home">Group Home</option>
                        <option value="Government Subsidized Housing">Government Subsidized Housing</option>
                        <option value="Substance Abuse Treatment Center">Substance Abuse Treatment Center</option>
                        <option value="Own Home">Own Home</option>
                        <option value="Place Not Meant for Habitation">Place Not Meant for Habitation</option>
                    </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && livingSituation.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="livingSituation.errors!.required">Living situation is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="mt-5 text-center">

                <!-- Save Profile -->
                <button type="submit" class="btn waves-dark">Update Info</button>

                <!-- Reset Password -->
                <button type="button" class="btn waves-dark" (click)="resetMode = !resetMode">Reset Password</button></div>
        </form>
    </div>
</section>

<!-- Reset Password Mode -->
<section *ngIf=resetMode>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
            <h1 class="text-center">Reset Password</h1>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Password -->
                    <div class="col-md-12">
                        <label class="required-field">New Password</label>
                        <input type="password" id="password" class="form-control mb-2" placeholder="Password" [(ngModel)]="update.password" name="password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" password required minlength="6">

                        <!-- Invalid Password -->
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="password.errors!.required">Password is required</div>
                            <div class="mb-1 text-center" *ngIf="password.errors!.minlength">Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Confirm Password -->
                    <div class="col-md-12">
                        <label class="required-field">Confirm New Password</label>
                        <input type="password" id="confirmPassword" class="form-control mb-2" placeholder="Repeat Password" [(ngModel)]="update.confirmPassword" name="confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }"
                            password required validateEqual="password" minlength="6">

                        <!-- Invalid Confirm Password -->
                        <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" [hidden]="confirmPassword.valid || (confirmPassword.pristine && !f.submitted)">Password and Confirm Password need to match</div>
                            <div class="mb-1 text-center" *ngIf="confirmPassword.errors!.minlength">Confirm Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit -->
            <div class="text-center">
                <button type="submit" class="my-4 btn">Submit</button>
            </div>
        </form>
    </div>
</section>
